import { computed, defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { Popover } from 'bootstrap';
import { useRouter } from 'vue-router';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { ProvinceTaskGetter } from '@/store/provinceTask/provinceTask.module';
import { ProvinceTask } from '@/store/provinceTask/provinceTask.model';
import { FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'ProvinceTaskTableComponent',
  components: {
    LoadingComponent,
  },
  props: {
    provinceTaskTypeId: {
      type: Number,
      required: true,
    },
    fiscalYearId: {
      type: Number,
    },
    provinceId: {
      type: Number
    },
  },
  setup: (props) => {
    const router = useRouter();
    const dateFormat = useDateFormat();
    const store = useStore();
    const fiscalYear = computed<FiscalYear>(() => store.getters[FiscalYearGetter.BY_ID](props.fiscalYearId));
    const provinceTasks = computed<ProvinceTask[]>(() => store.getters[ProvinceTaskGetter.BY_TYPE](props.provinceTaskTypeId, props.provinceId, fiscalYear.value?.startDate, fiscalYear.value?.endDate));
    const isLoading = computed(() => store.getters[ProvinceTaskGetter.STATUS] === 'init' || store.getters[ProvinceTaskGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const popoverList = ref<Popover[]>([]);

    onMounted(() => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    });

    watch(() => (props.provinceId), () => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const selectedClick = (id: number) => {
      const provinceTaskType = (props.provinceTaskTypeId !== 1)
        ? (props.provinceTaskTypeId !== 2)
          ? (props.provinceTaskTypeId !== 3)
            ? (props.provinceTaskTypeId !== 4)
              ? 'damrongdhama'
              : 'special'
            : 'economy'
          : 'important'
        : 'strategic';
      router.push(`/provincetasks/${provinceTaskType}/${id}`);
    };

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-emergency"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      provinceTasks,
      datatable,
      isLoading,
      selectedClick,
      thaiDate,
    };
  },
});
